// txcom-custom.js

// PAGETOPの挿入
(() => {
    // .wrapper 内の header.header の存在チェック
    const header = document.querySelector('.wrapper header.header');
  
    if (!header) return;
  
    const wrapper = document.querySelector('.wrapper');
  
    // 画像URLのランダム選定
    const images = [
      'https://cdn.shopify.com/s/files/1/0754/4923/7763/files/pagetop-3.png?v=1788156516',
      'https://cdn.shopify.com/s/files/1/0754/4923/7763/files/pagetop-2.png?v=1788156521',
      'https://cdn.shopify.com/s/files/1/0754/4923/7763/files/pagetop-1.png?v=1788156525'
    ];
    const randomSrc = images[Math.floor(Math.random() * images.length)];
  
    // .wrapper の一番最後に要素を挿入
    const pageTopHtml = `<div class="txcom-pagetop"><a href="#"><img src="${randomSrc}" alt="pagetop"></a></div>`;
    wrapper.insertAdjacentHTML('beforeend', pageTopHtml);
  
    const pageTopEl = wrapper.querySelector('.txcom-pagetop');
  
    // ページ最下部に到達したかのスクロール監視
    window.addEventListener('scroll', () => {
      // 画面の一番下までの距離を判定
      const scrollPosition = window.innerHeight + window.scrollY;
      const bodyHeight = document.documentElement.scrollHeight;
  
      // 最下部に達したら (誤差吸収のため512px手前で判定) fixed クラスを付与
      if (scrollPosition >= bodyHeight - 512) {
        pageTopEl.classList.add('fixed');
      } else {
        pageTopEl.classList.remove('fixed');
      }
    });
  
    // クリックイベント（スムーススクロール）
    pageTopEl.addEventListener('click', (e) => {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
})();